(() => {
  function initialize(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const chat = root.querySelector('[data-contact-chat]');
    const chatButton = root.querySelector('[data-open-contact-chat]');
    const launcher = () => document.querySelector('shopify-chat')?.shadowRoot?.querySelector('button[part="activator"]');
    if (chat && chatButton) {
      let attempts = 0;
      const reveal = () => {
        if (!root.isConnected) return;
        if (launcher()) chat.hidden = false;
        else if (++attempts < 60) setTimeout(reveal, 500);
      };
      reveal();
      chatButton.addEventListener('click', () => {
        const toggle = launcher();
        const status = root.querySelector('[data-contact-chat-status]');
        if (!toggle) {
          status.textContent = 'Chat is temporarily unavailable. Please use the message form instead.';
          return;
        }
        status.textContent = '';
        if (toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
      });
    }
    const topic = root.querySelector('[data-contact-topic]');
    const order = root.querySelector('[data-contact-order]');
    if (topic && order) {
      const update = () => {
        order.hidden = !['Existing reading order', 'Physical product order'].includes(topic.value);
        order.querySelector('input').disabled = order.hidden;
      };
      topic.addEventListener('change', update);
      update();
    }
    root.querySelector('[data-contact-success], [data-contact-error]')?.focus();
  }
  document.querySelectorAll('[data-contact-mira]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-contact-mira]').forEach(initialize);
  });
})();
